import React, { Component } from "react";

import { HashRouter, Route, Link } from 'react-router-dom';

import { Layout, Menu, Row, Col } from 'antd';


export default function NavbarMenu({ userType = 4 }) {
    if (userType == 4) {
        return (
            <div

                style={{
                    backgroundColor: '#f02',
                    borderBottomWidth: 2,
                    borderColor: 'blue'
                }}>

                <div className="row no-gutters">
                    <div className="col">
                        <div className="row no-gutters" style={{ height: 40 }}>
                            <div className="col-2" />

                            <div className="col-2">
                                <Link to="/" className="btn btn-glossred  w-100 rounded-0">
                                    Bahis Yap
                        </Link>
                            </div>
                            <div className="col-2">
                                <Link to="/webtv" className="btn btn-glossred  w-100 rounded-0">
                                    Web Tv
                        </Link>
                            </div>
                            <div className="col-2">
                                <Link to="/program" className="btn btn-glossred  w-100 rounded-0">
                                    Program
                    </Link>
                            </div>

                            <div className="col-2">
                                <Link to="/panel" className="btn btn-glossred  w-100 rounded-0">
                                    Yönetim
                                 </Link>
                            </div>

                            <div className="col-2">
                                <Link to="/panel/result" className="btn btn-glossred  w-100 rounded-0">
                                    Sonuçlar
                                 </Link>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        )
    }
    else {
        return (
            <div

                style={{
                    backgroundColor: '#000'
                }}>

                <div className="row no-gutters">
                    <div className="col">
                        <div className="row no-gutters" style={{ height: 40 }}>
                            <div className="col-2" />

                            <div className="col-2">
                                <Link to="/panel/user" className="btn text-white  w-100 rounded-0">
                                    Kullanıcılar
                    </Link>
                            </div>
                            <div className="col-2">
                                <Link to="/webtv" className="btn  text-white w-100 rounded-0">
                                    Rapor
                    </Link>
                            </div>
                            <div className="col-2">
                                <Link to="/program" className="btn  text-white w-100 rounded-0">
                                    Duyuru
                </Link>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
